import { useEffect, useState } from 'react';
import './announcement-modal.styles.scss';
import Modal from '@/components/modal/modal.component';
import { useSelector } from 'react-redux';
import { getQueryFromFirestore } from '@/utils/getDataFromDbSimplified';

const AnnouncementModal = () => {

  const userProfile = useSelector((state) => state.userData.userProfile);
  const [announcementList, setAnnouncementList] = useState([]);
  const [viewedList, setViewedList] = useState([]);
  const [modalContent, setModalContent] = useState(null);

  useEffect(() => {
    if (!userProfile) return;

    function getCurrentAnnouncements() {
      getQueryFromFirestore({
        'path': 'platform_announcements',
        'queryArray': [
          {
            'field': 'startDate',
            'operator': '<=',
            'value': Date.now()
          },
          {
            'field': 'endDate',
            'operator': '>=',
            'value': Date.now()
          }
        ],
        'callback': callback,
        'once': true
      })
      function callback(data) {
        setAnnouncementList(Object.values(data));
      }
    }

    getCurrentAnnouncements();
  }, [userProfile?.appId])

  useEffect(() => {
    for (let announcement of announcementList) {
      if (!viewedList.includes(announcement.id)) {
        setModalContent(announcement);
        break;
      }
    }
  }, [announcementList, viewedList])



  return (
    <div className='announcement-modal'>
      <Modal
        show={!!modalContent}
        cancel={() => setModalContent(null)}
        text={modalContent?.title} >
        <div className='announcement-modal-content'>
          <div dangerouslySetInnerHTML={{ __html: modalContent?.messageHtml }} />
          <div className="g-space-1"></div>
          <div className='buttons'>
            <button className='g-button' onClick={() => {
              setViewedList(prev => [...prev, modalContent.id]);
              setModalContent(null);
            }}>
              Got it
            </button>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default AnnouncementModal